// https://github.com/wandergis/coordtransform
import * as coordtransform from "coordtransform";
import { CRM_MENU, CRM_CURRENT_LEVEL_ONE_MENU, CRM_USER_INFO } from './keys';
import { doLogin } from './tianrunCall';
import { GetContactByUid, ccValidToken, Operation, GetDisplayNos,sendCallUp, DialClue, signOperate } from '../api/callCenter';
import { QueryWebrtcToken, StartNetCal,QueryCustomBaseInfo } from '../api/feiyu';
import { CheckIpAddress } from '../api/login';
import {getBaseUrl} from "./config";
import {getCookie} from "./cookie";
let feiyuCall = null;
let feiyuCallLogin = false;
let elementObj = null;
export function pointerEvents() {
    let arrCall = document.querySelectorAll('.pointer-events');
    arrCall.forEach(item => {
        item.classList.remove('pointer-events');
    })
}
export const startMarquee = (lh, speed, delay, id) => { // 消息滚动
    let t;
    let p = false;
    const o = document.getElementById(id);
    o.innerHTML += o.innerHTML + o.innerHTML + o.innerHTML;
    o.onmouseover = function() {
        p = true;
    }
    o.onmouseout = function() {
        p = false;
    }
    o.scrollTop = 0;

    function start() {
        t = setInterval(scrolling, speed);
        if (!p) o.scrollTop += 2;
    }

    function scrolling() {
        if (o.scrollTop % lh != 0) {
            o.scrollTop += 2;
            if (o.scrollTop >= o.scrollHeight / 2) o.scrollTop = 0;
        } else {
            clearInterval(t);
            setTimeout(start, delay);
        }
    }
    setTimeout(start, delay);
}
export function padding(v) {
    let value = v + '';
    if (value.length < 2) {
        value = '0' + value;
    }
    return value;
}
export function format(d) { //时间转换 => YYYY-MM-dd
    return !!d && typeof d !== 'string' ? (d.getFullYear() + '-' + padding(d.getMonth() + 1) + '-' + padding(d.getDate())) : d;
}
export function getWeekly(dateString) {
    let dateStringReg = /^\d{4}[/-]\d{1,2}[/-]\d{1,2}$/;
    dateString = format(dateString)
    if (dateString.match(dateStringReg)) {
        let presentDate = new Date(dateString),
            today = presentDate.getDay() !== 0 ? presentDate.getDay() : 7;

        return Array.from(new Array(7), function(val, index) {
            return format(new Date(presentDate.getTime() - (today - index-1) * 24 * 60 * 60 * 1000));
        });
    } else {
        throw new Error('dateString should be like "yyyy-mm-dd" or "yyyy/mm/dd"');
    }
}
export function getPreMonth(date) { // 获取上月日期
    var arr = date.split('-');
    var year = arr[0]; //获取当前日期的年份
    var month = arr[1]; //获取当前日期的月份
    var day = arr[2]; //获取当前日期的日
    var days = new Date(year, month, 0);
    days = days.getDate(); //获取当前日期中月的天数
    var year2 = year;
    var month2 = parseInt(month) - 1;
    if (month2 == 0) {
        year2 = parseInt(year2) - 1;
        month2 = 12;
    }
    var day2 = day;
    var days2 = new Date(year2, month2, 0);
    days2 = days2.getDate();
    if (day2 > days2) {
        day2 = days2;
    }
    if (month2 < 10) {
        month2 = '0' + month2;
    }
    var t2 = year2 + '-' + month2 + '-' + day2;
    return t2;
}
export function number2DateTime(value, fmt = 'yyyy-MM-dd HH:mm:ss') { // yyyy-MM-dd HH:mm:ss
    if (isNaN(value)) return '';
    const date = new Date(Number(value));
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    return fmt.replace('yyyy', year.toString())
        .replace('yy', (year % 100).toString())
        .replace('MM', month > 9 ? month.toString() : ("0" + month))
        .replace('dd', day > 9 ? day.toString() : ("0" + day))
        .replace('HH', hour > 9 ? (hour).toString() : ("0" + hour))
        .replace('mm', minute > 9 ? (minute).toString() : ("0" + minute))
        .replace('ss', second > 9 ? (second).toString() : ("0" + second));
}
export function number2DateTime0(value, fmt = 'yyyy-MM-dd HH:mm:ss') { // yyyy-MM-dd HH:mm:ss
    if (isNaN(value)) return value;
    const date = new Date(Number(value));
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    return fmt.replace('yyyy', year.toString())
        .replace('yy', (year % 100).toString())
        .replace('MM', month > 9 ? month.toString() : ("0" + month))
        .replace('dd', day > 9 ? day.toString() : ("0" + day))
        .replace('HH', hour > 9 ? (hour).toString() : ("0" + hour))
        .replace('mm', minute > 9 ? (minute).toString() : ("0" + minute))
        .replace('ss', second > 9 ? (second).toString() : ("0" + second));
}
export function trim(str) { // 去空格
    return str.replace(/\s/g, '');
}
export function isPhone(str) { // 手机号验证
    var reg = /^(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8}$/;
    if (reg.test(str)) {
        return true;
    } else {
        return false;
    }
}
export function isQQ(str) { // QQ号验证
    var reg = /^[1-9][0-9]{4,15}$/
    if (reg.test(str)) {
        return true;
    } else {
        return false;
    }
}
export function isEmail(str) { // 邮箱验证
    var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
    // var reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    if (reg.test(str)) {
        return true;
    } else {
        return false;
    }
}
export function isNumber(value) { // 数字验证  注释:数字0存在问题
    var patrn = /^[0-9]*$/;
    if (patrn.exec(value) == null || value == "") {
        return false
    } else {
        return true
    }
}
export function isPositive (value) { // 数字验证  注释:正整数
    var patrn = /(^[0-9]\d*$)/;
    if (patrn.exec(value) == null || value == "") {
        return false
    } else {
        return true
    }
}
export function isMoney(value) { // 验证输入金额
    var patrn = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
    if (patrn.exec(value) == null || value == "") {
        return false
    } else {
        return true
    }
}
export function isCardNo(card) {
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (reg.test(card)) {
        return false;
    } else {
        return true;
    }
}

/**
 * 获取本周、本季度、本月、上月的开端日期、停止日期
 */
var now = new Date(); //当前日期
var nowDayOfWeek = now.getDay() || 7; //今天本周的第几天
var nowDay = now.getDate(); //当前日
var nowMonth = now.getMonth(); //当前月
var nowYear = now.getYear(); //当前年
nowYear += (nowYear < 2000) ? 1900 : 0;

//获得某月的天数
export function getMonthDays(myMonth) {
    var monthStartDate = new Date(nowYear, myMonth, 1);
    var monthEndDate = new Date(nowYear, myMonth + 1, 1);
    var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
    return days;
}

//获得本周的开端日期
export function getWeekStartDate() {
    var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
    return format(weekStartDate);
}
//获得本周的停止日期
export function getWeekEndDate() {
    var weekEndDate = new Date(nowYear, nowMonth, nowDay + (7 - nowDayOfWeek));
    return format(weekEndDate);
}
//获得本月的开端日期
export function getMonthStartDate() {
    var monthStartDate = new Date(nowYear, nowMonth, 1);
    return format(monthStartDate);
}

//获得本月的停止日期
export function getMonthEndDate() {
    var monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth));
    return format(monthEndDate);
}

export function checkedUserTree(getclues) { // 获取当前所选中的姓名及ID方法
    let getCluesId = [];
    let objUserTree = {
        userId: [],
        userName: []
    };
    for (let i = 0; i < getclues.length; i++) {
        getCluesId.push(getclues[i].Id);
        if (Number(getCluesId[i]) == parseFloat(getCluesId[i])) {
            objUserTree.userId.push(getCluesId[i]);
            objUserTree.userName.push(getclues[i].Name);
        }
        if (getCluesId[i].toString().length > 25) {
            objUserTree.userId.push(getCluesId[i]);
            objUserTree.userName.push(getclues[i].Name);
        }
    }
    return objUserTree;
}
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function() {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
                // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function(...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
            // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}
export const messageTitle = { // title 消息提示
    time: 0,
    title: document.title,
    timer: null,
    // 显示新消息提示执行方法
    show: function() {
        var title = messageTitle.title;
        // 定时器，设置消息切换频率闪烁效果就此产生
        messageTitle.timer = setTimeout(function() {
            messageTitle.time++;
            messageTitle.show();
            if (messageTitle.time % 2 == 0) {
                document.title = "【新消息】" + title
            } else {
                document.title = "【　　　】" + title
            };
        }, 600);
        return [messageTitle.timer, messageTitle.title];
    },
    // 取消新消息提示方法
    clear: function() {
        clearTimeout(messageTitle.timer);
        document.title = messageTitle.title;
    }
}

//获取阿里呼叫状态
export function getCallStatus(self) {
    setTimeout(() => {
        let callStatus = window.workbench.getStatusCode();
        self.$store.dispatch("setCallStatus", callStatus.code);
    }, 300);
}
//电话接听
export function answerCall(self, phoneType) {
    if (phoneType == 3) {
        if (CTILink.SipSession.isSessionAlive()) {
            CTILink.SipSession.sipLink();
        } else {
            console.log("软电话接听失败，sipSession不存在或已经销毁");
        }
    } else {
        window.workbench.answer();
    }
}
//挂断电话
export function hangupCall(self, extNo) {
    self.$store.dispatch('hangupCall', { "ExtNO": extNo });
}

//阿里拨打电话
export function aliCCCall(uInfo, to) {
    pointerEvents();
    if (!to) {
        return;
    }
    if (!uInfo) {
        Message({
            message: '请联系管理员配置呼叫中心',
            showClose: true,
            type: 'warning'
        });
        return;
    }
    var status = window.workbench.getStatusCode();
    console.log("ali status:", status);
    if (status) {
        if (status.code == 1) {
            window.workbench.logIn();
        } else if (status.code == 12) {
            window.workbench.callRetrieve();
            window.workbench().hangUp();
        } else if (status.code == 8) {
            window.workbench.hangUp();
        }
    }
    setTimeout(() => {
        if (!uInfo.MqPhone) {
            window.workbench.call(to);
        } else {
            window.workbench.call(to, uInfo.MqPhone);
        }
    }, 500);
}


//天润拨打电话
export function tianRunCCCall(to) {
    executeAction('doPreviewOutCall', {
        "tel": to,
        "callType": "3"
    });
}
export function doPreviewOutcall (params,clueGuid, self) {
    CTILink.Agent.previewOutcall(params, (type) => {
        let message = '', errorCode = type.errorCode + ''
        if(type.code == -1) {
            switch (errorCode) {
                case '10001':
                    message = '系统异常'
                    break;
                case '20000':
                    message = '参数错误'
                    break;
                case '20011':
                    message = '座席繁忙'
                    break;
                case '20012':
                    message = '座席不存在或不在线'
                    break;
                case '20016':
                    message = '没有外呼权限'
                    break;
                case '20024':
                    message = '没有开启外呼功能'
                    break;
                case '20031':
                    message = '号码在黑名单中，或不在白名单中(被限制号码，请使用其他方式联系客户)'
                    self.$store.dispatch("updateTrCludeStatus", {state: '空闲',stateAction: 'errorNumber', customerNumber: ''});
                    break;
                case '20051':
                    message = '号码超频'
                    self.$store.dispatch("updateTrCludeStatus", {state: '空闲',stateAction: 'errorNumber', customerNumber: ''});
                    break;
                case '20052':
                    message = '号码在RMS黑名单中(被限制号码，请使用其他方式联系客户)'
                    self.$store.dispatch("updateTrCludeStatus", {state: '空闲',stateAction: 'errorNumber', customerNumber: ''});
                    break;
                case '20101':
                    message = '外呼时间限制'
                    break;
                case '20102':
                    message = '空号或号码格式不正确'
                    self.$store.dispatch("updateTrCludeStatus", {state: '空闲',stateAction: 'errorNumber', customerNumber: ''});
                    break;
                case '20103':
                    message = '锁定座席失败'
                    break;
            }
            self.$message({
                message: '外呼失败，' + message,
                type: 'warning'
            });
        } else {
            SignOutbound(clueGuid)
        }
    });
}
export function doTianRunOutcall(tel,clueGuid,userId, self, channelId, PartialPhone) {
    pointerEvents();
    if (!tel) {
        return;
    }

    if (channelId) {
        GetDisplayNos({
            channelId: channelId,
            callcenterId: PartialPhone,
        }).then(res => {
            if (res.status === 0) {
                let params = {
                    tel: tel,
                    obClid: res.result,
                    userField:{
                        clueGuid:clueGuid+'',
                        callSource:1,
                        userId:userId
                    }
                };

                if(self.$store.state.navigation.kickOut === 'HasKickOuted') {
                    doLogin(self, function(res) {
                        self.$store.dispatch('updateKickOut', '')
                        if (res.code == 0) {
                            //座席登录成功
                            doPreviewOutcall(params, clueGuid,  self)
                        } else {
                            //座席登录失败，失败原因： + result.msg
                            self.$message({
                                type: 'warning',
                                message: '坐席掉线，请重新签入！'
                            })
                            self.$store.dispatch("updateTrCludeStatus", {state: '',stateAction: '', customerNumber: ''});
                        }
                    })
                } else {
                    doPreviewOutcall(params, clueGuid, self)
                }
            } else  {
                let params = {
                    tel: tel,
                    userField:{
                        clueGuid:clueGuid+'',
                        callSource:1,
                        userId:userId
                    }
                };

                if(self.$store.state.navigation.kickOut === 'HasKickOuted') {
                    doLogin(self, function(res) {
                        self.$store.dispatch('updateKickOut', '')
                        if (res.code == 0) {
                            //座席登录成功
                            doPreviewOutcall(params, self)
                        } else {
                            //座席登录失败，失败原因： + result.msg
                            self.$message({
                                type: 'warning',
                                message: '坐席掉线，请重新签入！'
                            })
                            self.$store.dispatch("updateTrCludeStatus", {state: '',stateAction: '', customerNumber: ''});
                        }
                    })
                } else {
                    doPreviewOutcall(params, self)
                }
            }
        }).catch(error => {
            let params = {
                tel: tel,
                userField:{
                    clueGuid:clueGuid+'',
                    callSource:1,
                    userId:userId
                }
            };
            if(self.$store.state.navigation.kickOut === 'HasKickOuted') {
                doLogin(self, function(res) {
                    self.$store.dispatch('updateKickOut', '')
                    if (res.code == 0) {
                        //座席登录成功
                        doPreviewOutcall(params, self)
                    } else {
                        //座席登录失败，失败原因： + result.msg
                        self.$message({
                            type: 'warning',
                            message: '坐席掉线，请重新签入！'
                        })
                        self.$store.dispatch("updateTrCludeStatus", {state: '',stateAction: '', customerNumber: ''});
                    }
                })
            } else {
                doPreviewOutcall(params, self)
            }
        })
    } else {
        let params = {
            tel: tel,
            userField:{
                clueGuid:clueGuid+'',
                callSource:1,
                userId:userId
            }
        };
        if(self.$store.state.navigation.kickOut === 'HasKickOuted') {
            doLogin(self, function(res) {
                self.$store.dispatch('updateKickOut', '')
                if (res.code == 0) {
                    //座席登录成功
                    doPreviewOutcall(params, self)
                } else {
                    //座席登录失败，失败原因： + result.msg
                    self.$message({
                        type: 'warning',
                        message: '坐席掉线，请重新签入！'
                    })
                    self.$store.dispatch("updateTrCludeStatus", {state: '',stateAction: '', customerNumber: ''});
                }
            })
        } else {
            doPreviewOutcall(params, self)
        }
    }
}
//
export function tianrunCCLogin() {
    let userInfo = JSON.parse(localStorage.getItem(CRM_USER_INFO));
    var params = {
        hotLine: userInfo.TrHotLine,
        cno: userInfo.TrAgentNo,
        pwd: userInfo.TrPwd,
        bindTel: userInfo.TrBindTel,
        bindType: "1",
        initStatus: "online"
    };
    window.executeAction('doLogin', params); //执行登陆
}
//阿里云CC
export function signAliYunCC(operate, self) {
    let statusCode = self.$store.state.navigation.aliCallStatus;
    console.log("ali status:", statusCode);
    switch (operate) {
        case 1: //签入
            if (statusCode == 1)
                window.workbench.logIn();
            break;
        case 2: //签出
            window.workbench.logOut();
            break;
        case 3: //置忙
            window.workbench.applyForBreak();
            break;
        case 4: //置闲
            window.workbench.ready();
            break;
    }
}
//天润云CC
export function signTianRunYunCC(operate) {
    switch (operate) {
        case 1: //签入
            tianrunCCLogin()
            break;
        case 2: //签出
            window.executeAction("doLogout", { "type": "1" });
            break;
        case 3: //置忙
            window.executeAction('doPause', { "description": "置忙" });
            break;
        case 4: //置闲
            window.executeAction('doUnpause');
            break;
    }
}

// 汉天
export function doHanTianCall(jsonDate, self) {
    // const OperationUrl = '//192.168.0.21/Operation'
    // const OperationUrl = 'https://192.168.0.240:8443'
    // const OperationUrl = 'https://cti.songshuai.com:8443'
    // $.ajax({
    //     url: OperationUrl + '/callengine/http/operation?json='+ JSON.stringify(jsonDate),
    //     type: 'get',
    //     success: function (res) {
    //     },
    //     complete:function (XMLHttpRequest,textStatus) {
    //         pointerEvents();
    //         if(textStatus === 'timeout') {
    //             self.$message({
    //                 'type': 'warning',
    //                 message: '呼叫超时！'
    //             })
    //         } else if (textStatus === 'error') {
    //             self.$message({
    //                 'type': 'warning',
    //                 message: '呼叫失败！'
    //             })
    //         }
    //     }
    // })
    // Operation({
    //     json: JSON.stringify(jsonDate)
    // })

    sendCallUp(jsonDate).then(ret => {
        if (ret.status === 0) {
            SignOutbound(jsonDate.ClueGuid)
        }
    });
}
// 拨打电话
/**
 * { this, Uid, 号码,   号码类型,   CustomGuid, Guid}
 */
function callFun() {
    return new Promise(resolve => {
        CheckIpAddress().then(ret=>{
            if (ret.status === 0) {
                resolve(ret.result)
            }
        }).catch(()=>{})
    })
}

// 标记线索已拨打
function SignOutbound (ClueGuid) {
    if (ClueGuid) {
        DialClue({
            ClueGuid
        })
    }

}

export function initFeiyu(){
    let host = location.host;
    feiyuCall = new window.FeiyuCall({
        view: true,
        debug: host.indexOf('pangu') > -1?false:true,
        onInit: () => {
            // 调用 MAPI 接口获取网络电话签名，并将签名信息当作入参传入给 init
            QueryWebrtcToken().then(ret=>{
                if(!ret.status){
                    feiyuCall.init(ret.result.token);
                }
            });
        },
        onStatusChange: (status,data) => {
            //回拨时查询客户名
            if(status=="CALL_RINGING" && data.caller){
                QueryCustomBaseInfo({'Phone':data.caller}).then(ret=>{
                    if(!ret.status){
                        feiyuCall.setCallInfo({
                            entityName: ret.result.truename,
                            entityPhone: data.caller,
                        });
                    }
                });
            } else if(status=="READY") {
                if(elementObj){
                    elementObj.classList.remove('pointer-events');
                }
                if(feiyuCallLogin){
                    return;
                }
                const userInfo = JSON.parse(localStorage.getItem(CRM_USER_INFO));
                let extInfo = {
                    UserNo: userInfo.UserId,
                    ExtNo: userInfo.PartialPhone,
                    Operate:0,
                    Operate:1,
                    OperateType:1,
                    IsFish:1,
                };
                signOperate(extInfo).then(ret=>{
                    if(!ret.status){
                        feiyuCall.setCallInfo({
                            entityName: ret.result.truename,
                            entityPhone: data.caller,
                        });
                    }
                });
                feiyuCallLogin = true;
            } else if(status=='WRAPUP'){//挂断
                // pointerEvents()
            }
        },
    });
}

export async function getCallUp(el, self, Uid, mobile, phoneType, CustomGuid, Guid, channelId) {
    elementObj = el;
    if(!feiyuCallLogin){
        getCallUpOld(el, self, Uid, mobile, phoneType, CustomGuid, Guid, channelId);
        return;
    }
    // 示例代码
    const { code, msg } = await feiyuCall.checkReadyCall();
    let callStatus = self.$store.state.navigation.extStatusId;
    if (code) {
        // 开启sdk的视图的话，可以不用管错误处理
        self.$message({
            type: "warning",
            message: msg
        });
        el.classList.remove('pointer-events');
    } else {
        StartNetCal({ "ClueGuid":Guid, 'MobileId':Uid, 'CustomGuid':CustomGuid }).then(ret => {
            if(ret.status){
                getCallUpOld(el, self, Uid, mobile, phoneType, CustomGuid, Guid, channelId)
            }else{
                if(ret.result && ret.result.contact_id){
                    feiyuCall.setCallInfo({
                        entityName: ret.result.cust_name                            ,
                        entityPhone: ret.result.mobile,
                    });
                }else{
                    self.$message({
                        type: "warning",
                        message: ret.result?ret.result.call_result_message:''
                    });
                    getCallUpOld(el, self, Uid, mobile, phoneType, CustomGuid, Guid, channelId)
                    // el.classList.remove('pointer-events');
                }
            }
        }).catch((res) => {
            self.$message({
                type: "warning",
                message: res.msg
            });
        });
    }
}

export async function getCallUpOld(el, self, Uid, mobile, phoneType, CustomGuid, Guid, channelId) {
    // let phoneNum = '';
    // if (mobile.substring(0,2) == '01' && mobile.substring(0,2) !== '010') {
    //     phoneNum = mobile.slice(1, mobile.length);
    // } else {
    //     phoneNum = mobile
    // }
    // mobile = localStorage.getItem('testTel') || mobile
    console.log(el, self, Uid, mobile, phoneType, CustomGuid, Guid, channelId);
    if(feiyuCall){
        // 示例代码
        // const { code, msg } = await feiyuCall.checkReadyCall();
        // if (code) {
        //     // 开启sdk的视图的话，可以不用管错误处理
        //     self.$message({
        //         type: "warning",
        //         message: msg
        //     });
        // } else {
        //     StartNetCal({ "ClueGuid":Guid, 'MobileId':Uid, 'CustomGuid':CustomGuid }).then(ret => {
        //         if(ret.status){
        //             self.$message({
        //                 type: "warning",
        //                 message: (ret.result?ret.result.call_result_message:'') || ret.info
        //             });
        //         }else{
        //             if(ret.result && ret.result.contact_id){
        //                 feiyuCall.setCallInfo({
        //                     entityName: ret.result.cust_name                            ,
        //                     entityPhone: ret.result.mobile,
        //                 });
        //             }else{
        //                 self.$message({
        //                     type: "warning",
        //                     message: ret.result?ret.result.call_result_message:''
        //                 });
        //             }
        //         }
        //     }).catch((res) => {
        //         self.$message({
        //             type: "warning",
        //             message: res.msg
        //         });
        //     });
        // }
        // return;
    }
    // 判断ip地址 能否打电话
    let callState = await callFun();
    if (!callState) {
        self.$message({
            type: "warning",
            message: '当前非公司网络，无法拨打电话'
        });
        return false;
    }
    let userInfo = JSON.parse(localStorage.getItem(CRM_USER_INFO));
    // userInfo.HanTianCno = '1002'
    // userInfo.CallCenterType = 4

    let queryParm = { UserNo: userInfo.UserId, ExtNo: userInfo.PartialPhone };
    self.$store.dispatch("setCallInfo", 0); //将通话ID置为0
    //self.$store.dispatch('getExtStatus', queryParm);
    let callStatus = self.$store.state.navigation.extStatusId;
    if (Guid && callStatus == 2) {
        let trackingGuid = {
            CustomGuid,
            Guid,
            Uid
        }
        self.$store.dispatch('isTracking', true);
        self.$store.dispatch('getTrackingIds', trackingGuid);
    }
    if (callStatus == 1) {
        self.$message({
            message: '请先签入,再拨打电话',
            type: 'warning'
        });
        el.classList.remove('pointer-events')
        return;
    } else if (callStatus == 3) {
        self.$message({
            message: '请先置闲，再拨打电话',
            type: 'warning'
        });
        el.classList.remove('pointer-events')
        return;
    } else if (callStatus == 4) {
        self.$message({
            message: '通话中, 请稍后再试',
            type: 'warning'
        });
        el.classList.remove('pointer-events')
        return;
    } else if (callStatus == 2) {
        if (mobile.indexOf('*') == -1) { // 电话明文
            let phoneNum = '';
            if (mobile.substring(0, 2) == '01' && mobile.substring(0, 2) !== '010') {
                phoneNum = mobile.slice(1, mobile.length);
            } else {
                phoneNum = mobile
            }
            if (userInfo.CallCenterType == 2) {
                ccValidToken({ "userId": userInfo.UserId }).then(ret => {
                    aliCCCall(userInfo.SysAliyunMq ? userInfo.SysAliyunMq[0] : null, phoneNum);
                }).catch(() => {
                    aliCCCall(userInfo.SysAliyunMq ? userInfo.SysAliyunMq[0] : null, phoneNum);
                });

            } else if (userInfo.CallCenterType == 3) {
                doTianRunOutcall(phoneNum,Guid,userInfo.UserId, self, channelId || false, userInfo.TrDepartId);
            } else if (userInfo.CallCenterType == 4) {
                self.$store.dispatch("updateTrCludeStatus", {state: "呼叫中",stateAction: 'calling', customerNumber: ''});
                doHanTianCall({
                    CallCenterType:userInfo.CallCenterType,
                    ClueGuid:Guid,
                    Phone:String(phoneNum)
                });
            } else {
                self.$store.dispatch('callUp', {
                    UserNo: userInfo.UserId,
                    FromNo: userInfo.PartialPhone,
                    ToNo: phoneNum,
                    ClueId: Guid,
                    ClueGuid: Guid,
                })
            }
            el.classList.remove('pointer-events');
        } else {
            let sendCall = {
                id: Uid,
                IsCall: true
                // mobile,
                // phoneType
            }
            GetContactByUid(sendCall).then(ret => { // 获取手机号码明文
                if (ret.status === 0) {
                    let phoneNum = '';
                    if (ret.result.substring(0, 2) == '01' && ret.result.substring(0, 2) !== '010') {
                        phoneNum = ret.result.slice(1, ret.result.length);
                    } else {
                        phoneNum = ret.result
                    }
                    if (userInfo.CallCenterType == 2) {
                        ccValidToken({ "userId": userInfo.UserId }).then(ret => {
                            aliCCCall(userInfo.SysAliyunMq ? userInfo.SysAliyunMq[0] : null, phoneNum);
                        }).catch(() => {
                            aliCCCall(userInfo.SysAliyunMq ? userInfo.SysAliyunMq[0] : null, phoneNum);
                        });
                    } else if (userInfo.CallCenterType == 3) {
                        doTianRunOutcall(phoneNum,Guid,userInfo.UserId, self, channelId || false, userInfo.TrDepartId);
                    } else if (userInfo.CallCenterType == 4) {
                        self.$store.dispatch("updateTrCludeStatus", {state: "呼叫中",stateAction: 'calling', customerNumber: ''});
                        doHanTianCall({
                            CallCenterType:userInfo.CallCenterType,
                            ClueGuid:Guid,
                            Phone:String(phoneNum)
                        });
                    } else {
                        self.$store.dispatch('callUp', {
                            UserNo: userInfo.UserId,
                            FromNo: userInfo.PartialPhone,
                            ToNo: phoneNum.replace('-', ''),
                            ClueId: Guid,
                            ClueGuid: Guid,
                        })
                    }
                    el.classList.remove('pointer-events');
                } else {
                    self.$message({
                        message: '拨打电话失败，请稍后再试',
                        type: 'warning'
                    });
                    return;
                }
            }).catch((error) => {
                self.$message({
                    message: '拨打电话失败，请稍后再试',
                    type: 'warning'
                });
            });
        }
    } else {
        self.$message({
            message: '服务未处理异常',
            type: 'warning'
        });
        el.classList.remove('pointer-events');
    }

}


//解析Url
export function parseQueryString(url) {
    var obj = {};
    var start = url.indexOf("?") + 1;
    var str = url.substr(start);
    var arr = str.split("&");
    for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("=");
        obj[arr2[0]] = arr2[1];
    }
    return obj;
}

export const isIE9 = () => {
    var DEFAULT_VERSION = "9.0";
    var ua = navigator.userAgent.toLowerCase();
    var IE = ua.indexOf("msie") > -1;
    var safariVersion;
    if (IE) {
        safariVersion = ua.match(/msie ([\d.]+)/)[1];
        if (safariVersion == DEFAULT_VERSION) {
            return true;
        }
    }
    return false;
}
export const isIP = (ip) => { // IP格式验证
    var reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
    if (reg.test(ip) && (RegExp.$1<256 && RegExp.$2<256 && RegExp.$3<256 && RegExp.$4<256)) {
        return true;
    } else {
        return false;
    }
}
export function diff(obj1, obj2) { // 对象比较
    var o1 = obj1 instanceof Object;
    var o2 = obj2 instanceof Object;
    if (!o1 || !o2) { /*  判断不是对象  */
        return obj1 === obj2;
    }

    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
        //Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,例如：数组返回下表：let arr = ["a", "b", "c"];console.log(Object.keys(arr))->0,1,2;
    }

    for (var attr in obj1) {
        var t1 = obj1[attr] instanceof Object;
        var t2 = obj2[attr] instanceof Object;
        if (t1 && t2) {
            return diff(obj1[attr], obj2[attr]);
        } else if (!obj1[attr] && !obj2[attr]) {
            continue;
        } else if (obj1[attr] !== obj2[attr]) {
            return false;
        }
    }
    return true;
}

export function clone(obj) { // 深复制
    var copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = clone(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}
export const exportExl = (url,data={},fileName='', methods='post') => {
    let xhr = new XMLHttpRequest()
    xhr.open(methods, getBaseUrl() + url, true)
    xhr.responseType = 'blob'
    xhr.setRequestHeader("Authorization", getCookie('CRM_TOKEN')) // 请求头中的验证信息等（如果有）
    xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8")
    xhr.onload = function() {
        if (this.status === 200) {
            let type = xhr.getResponseHeader('Content-Type')
            let blob = new Blob([this.response], {type: type})
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                window.navigator.msSaveBlob(blob, fileName)
            } else {
                let URL = window.URL || window.webkitURL
                let objectUrl = URL.createObjectURL(blob)
                if (fileName) {
                    let a = document.createElement('a')
                    if (typeof a.download === 'undefined') {
                        window.location = objectUrl
                    } else {
                        a.href = objectUrl
                        a.download = fileName
                        document.body.appendChild(a)
                        a.click()
                        a.remove()
                    }
                } else {
                    window.location = objectUrl
                }
            }
        }
    }
    xhr.send(JSON.stringify(data))
}
/**
 * 经纬度转换（高德转百度, gcj02tobd09）
 * @param gglat 纬度
 * @param gglon 经度
 * @example convertAMapToBMap(39.915, 116.404)
 */
export function convertAMapToBMap(gglat, gglon) {
  const [bdlon, bdlat] = coordtransform.gcj02tobd09(gglon, gglat);
  return {
    lng: bdlon,
    lat: bdlat,
  };
}